/**
 * A comparison before its diff lands: the summary's four figures under their
 * real labels, then the register of changes in bones.
 *
 * @module components/portfolio/comparison/ComparisonLoading
 */

import React from "react";

import { StatCard } from "@/components/ui";
import { ListBones } from "@/components/ui/SkeletonParts";

const METRICS = [
  "Changes recorded",
  "Modules changed",
  "Mapping links changed",
  "Outputs affected",
] as const;

/** `label` is drawn as text for a screen whose own live region announces it. */
export function ComparisonLoading({ label = undefined }: { label?: string }): React.ReactElement {
  return (
    <div className="flex flex-col gap-4">
      {label ? <span className="sr-only">{label}</span> : null}
      <div className="grid gap-4 py-5 sm:grid-cols-2 lg:grid-cols-4">
        {METRICS.map((metric) => (
          <StatCard key={metric} label={metric} value={null} loading="silent" />
        ))}
      </div>
      <ListBones rows={4} />
    </div>
  );
}
